import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import moment from 'moment'; // 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
// eslint-disable-next-line no-extend-native

Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1,
    // 月份
    'd+': this.getDate(),
    // 日
    'h+': this.getHours(),
    // 小时
    'm+': this.getMinutes(),
    // 分
    's+': this.getSeconds(),
    // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3),
    // 季度
    'S': this.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }

  return fmt;
};

export function formatTimeToStr(times, pattern) {
  var d = new Date(times).Format('yyyy-MM-dd hh:mm:ss');

  if (pattern) {
    d = new Date(times).Format(pattern);
  }

  return d.toLocaleString();
}
/**
 * end是否在m日范围内
 * @return true end在限制日期内
 */

export function isBeforeDate(start, end, m) {
  if (start === '') {
    return true;
  }

  var endLimit = new Date(start);
  endLimit.setDate(endLimit.getDate() + m);

  if (new Date(end).getTime() < new Date(start).getTime()) {
    return false;
  }

  return new Date(end).getTime() <= endLimit.getTime();
}
/**
 * end是否在m个月范围内
 * @return true end在限制月份内
 */

export function isBeforeMonth(start, end, m) {
  var pickerTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'dateTime';

  if (start === '') {
    return true;
  }

  var endLimit = moment(start).add(m, 'months').toDate();

  if (pickerTime === 'date') {
    // 日期选择结束时间需减一天
    endLimit.setDate(endLimit.getDate() - 1);
  }

  if (new Date(end).getTime() < new Date(start).getTime()) {
    return false;
  }

  return new Date(end).getTime() <= endLimit.getTime();
}
/**
 * 获取n个月后日期
 */

export function nowDiffMonth(n) {
  var dt = new Date();
  dt.setMonth(dt.getMonth() + Number(n));
  return dt.Format('yyyy-MM-dd 00:00:00');
}
/**
 * 指定日期n个月后日期
 */

export function afterDiffMonth(dateStr, n) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'yyyy-MM-dd 00:00:00';
  var dt = new Date(dateStr);
  dt.setMonth(dt.getMonth() + Number(n));
  return dt.Format(format);
}
/**
 * 指定日期n年后日期
 */

export function afterDiffYear(dateStr, n) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'yyyy-MM-dd 00:00:00';
  var dt = new Date(dateStr);
  dt.setFullYear(dt.getFullYear() + Number(n));
  return dt.Format(format);
}
/**
 * 指定日期n个月前日期
 */

export function beforeDiffMonth(dateStr, n) {
  var dt = new Date(dateStr);
  dt.setMonth(dt.getMonth() - Number(n));
  return dt.Format('yyyy-MM-dd 00:00:00');
}
/**
 * n天前日期
 */

export function beforeDiffDate(dateStr, n, format) {
  var date = new Date(dateStr);
  date.setDate(date.getDate() - n);
  return date.Format(format || 'yyyy-MM-dd 00:00:00');
}
/**
 * n天后日期
 */

export function diffDate(n, format) {
  var date = new Date();
  date.setDate(date.getDate() + n);
  return date.Format(format || 'yyyy-MM-dd 00:00:00');
}
/**
 * n天后日期
 */

export function afterDiffDate(dateStr, n, format) {
  var date = new Date(dateStr);
  date.setDate(date.getDate() + n - 1);
  return date.Format(format || 'yyyy-MM-dd 00:00:00');
}
/**
 * 今天开始时间
 */

export function todayStartStr(dateStr) {
  if (dateStr) {
    return new Date(dateStr).Format('yyyy-MM-dd 00:00:00');
  }

  return new Date().Format('yyyy-MM-dd 00:00:00');
}
/**
 * 今天结束时间
 */

export function todayEndStr(dateStr) {
  if (dateStr) {
    return new Date(dateStr).Format('yyyy-MM-dd 23:59:59');
  }

  return new Date().Format('yyyy-MM-dd 23:59:59');
}
/**
 * 昨天开始时间
 */

export function yesterdayStartStr() {
  return new Date(new Date().setDate(new Date().getDate() - 1)).Format('yyyy-MM-dd 00:00:00');
}
/**
 * 昨天结束时间
 */

export function yesterdayEndStr() {
  return new Date(new Date().setDate(new Date().getDate() - 1)).Format('yyyy-MM-dd 23:59:59');
}
/**
 * 获取星期几
 */

export function getWeekDay(dateStr) {
  var weekday = new Date(dateStr).getDay();
  var week = '';

  switch (weekday) {
    case 0:
      week = '星期日';
      break;

    case 1:
      week = '星期一';
      break;

    case 2:
      week = '星期二';
      break;

    case 3:
      week = '星期三';
      break;

    case 4:
      week = '星期四';
      break;

    case 5:
      week = '星期五';
      break;

    case 6:
      week = '星期六';
      break;
  }

  return week;
}
/**
 * 本周开始时间
 */

export function weekStartStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  var weekday = date.getDay() || 7;
  date.setDate(date.getDate() - weekday + 1);
  return date.Format('yyyy-MM-dd 00:00:00');
}
/**
 * 本周结束时间
 */

export function weekEndStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  var weekday = date.getDay() || 7;
  date.setDate(date.getDate() - weekday + 7);
  return date.Format('yyyy-MM-dd 23:59:59');
}
/**
 * 月开始时间
 */

export function monthStartStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  date.setDate(1);
  return date.Format('yyyy-MM-dd 00:00:00');
}
/**
 * 月结束时间
 */

export function monthEndStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  date.setDate(28);
  date.setMonth(date.getMonth() + 1);
  date.setDate(0);
  return date.Format('yyyy-MM-dd 23:59:59');
}
/**
 * 本季度开始时间
 */

export function quarterStartStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  var month = date.getMonth();

  if (month < 3) {
    date.setMonth(0);
  } else if (month > 2 && month < 6) {
    date.setMonth(3);
  } else if (month > 5 && month < 9) {
    date.setMonth(6);
  } else if (month > 8 && month < 11) {
    date.setMonth(9);
  }

  date.setDate(1);
  return date.Format('yyyy-MM-dd 00:00:00');
}
/**
 * 本季度结束时间
 */

export function quarterEndStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  var month = date.getMonth();

  if (month < 3) {
    date.setMonth(3);
  } else if (month > 2 && month < 6) {
    date.setMonth(6);
  } else if (month > 5 && month < 9) {
    date.setMonth(9);
  } else if (month > 8 && month < 11) {
    date.setMonth(12);
  }

  date.setDate(0);
  return date.Format('yyyy-MM-dd 23:59:59');
}
/**
 * 当年开始时间
 */

export function yearStartStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  date.setDate(1);
  date.setMonth(0);
  return date.Format('yyyy-MM-dd 00:00:00');
}
/**
 * 当年结束时间
 */

export function yearEndStr(dateStr) {
  var date = dateStr ? new Date(dateStr) : new Date();
  date.setFullYear(date.getFullYear() + 1);
  date.setMonth(0);
  date.setDate(0);
  return date.Format('yyyy-MM-dd 23:59:59');
}
/**
 * 当日、当周、当月、当年
 */

export function getStartAndEnd(timeTag, dateTime) {
  if (timeTag === 'date') {
    return [todayStartStr(dateTime), todayEndStr(dateTime), parseInt(new Date(dateTime).Format('yyyyMMdd'))];
  }

  if (timeTag === 'week') {
    return [weekStartStr(dateTime), weekEndStr(dateTime)];
  }

  if (timeTag === 'month') {
    return [monthStartStr(dateTime), monthEndStr(dateTime), parseInt(new Date(dateTime).Format('yyyyMM'))];
  }

  if (timeTag === 'quarter') {
    return [quarterStartStr(dateTime), quarterEndStr(dateTime)];
  }

  if (timeTag === 'year') {
    return [yearStartStr(dateTime), yearEndStr(dateTime), parseInt(new Date(dateTime).Format('yyyy'))];
  }

  return [];
}